/* Martin Jewelry sections: scroll reveals + parallax drift on script words.
   Safe to load more than once; it only initialises one time. */
(function () {
  if (window.__mjSections) return;
  window.__mjSections = true;

  var root = document.documentElement;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Content is only hidden for the reveal once this class is present,
  // so if this script never runs nothing stays invisible.
  root.classList.add('mj-js');

  var io = ('IntersectionObserver' in window) && !designMode && !reduced
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15 })
    : null;

  function initReveals(scope) {
    (scope || document).querySelectorAll('.mj .mj-reveal:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  var layers = [];
  function collectLayers() { layers = Array.prototype.slice.call(document.querySelectorAll('.mj .mj-script-layer')); }

  function drift() {
    var vh = window.innerHeight;
    layers.forEach(function (layer) {
      var rect = layer.parentElement.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) return;
      var speed = parseFloat(layer.getAttribute('data-drift') || 0.3);
      var offset = (vh - rect.top) * speed;
      layer.style.transform = 'translateX(' + (-140 + offset * 0.4) + 'px)';
    });
  }

  function init() {
    initReveals(document);
    collectLayers();
    if (!reduced) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { drift(); ticking = false; });
      }, { passive: true });
      drift();
    }
  }

  // Theme editor: re-run when a section is added, edited, or reordered.
  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target); collectLayers(); drift();
  });
  document.addEventListener('shopify:section:reorder', function () { collectLayers(); drift(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
